import React from "react";
import { compose } from "recompose";
import { connect } from "react-redux";
import { Component, ComponentType } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Selector } from "reselect";

import { AuthState } from "../../models";
import { getIsAuthenticated } from "../../selectors";

interface AuthenticationProps extends RouteComponentProps<any> {
    authenticated: boolean;
    state: AuthState;
}

function RequiresAuth(
    ComposedComponent: ComponentType<{params?: any}>,
    loginUrl: string,
    selector: Selector<AuthState, boolean> = null,
) {

    class Authentication extends Component<AuthenticationProps> {
        public componentWillMount(): void {
            const { authenticated, state, history } = this.props;
            if (!authenticated) {
                history.push(loginUrl);
            }
            else if (selector != null && !selector(state)) {
                history.push("/");
            }
        }

        public componentWillUpdate(nextProps: AuthenticationProps): void {
            const { authenticated, state, history } = nextProps;
            if (!authenticated) {
                history.push(loginUrl);
            }
            else if (selector != null && !selector(state)) {
                history.push("/");
            }
        }

        public render(): JSX.Element {
            const params = this.props.match != null ? this.props.match.params : null;
            return <ComposedComponent params={params} />;
        }
    }

    function mapStateToProps(state: AuthState) {
        return {
            authenticated: getIsAuthenticated(state),
            state,
        } as AuthenticationProps;
    }

    return compose(
        withRouter,
        connect(mapStateToProps, null),
    )(Authentication);
}

export {
    RequiresAuth,
};
